import{getMixer as r}from"./complex.mjs.js";import{mixNumber as e}from"./number.mjs.js";function m(m,o,t){if("number"==typeof m&&"number"==typeof o&&"number"==typeof t)return e(m,o,t);return r(m)(m,o)}export{m as mix};
